import { queryOptions } from '@tanstack/react-query'
import invoiceApi from 'api/invoiceApi'
import _ from 'lodash'

export const queries = {
  base: {
    scope: ['handleInvoice', 'listAdjustedInvoice'],
    entity: 'listAdjustedInvoice',
  },
  lists: (params) =>
    queryOptions({
      staleTime: 1000 * 30,
      queryKey: [queries.base, params],
      queryFn: () =>
        invoiceApi.listAll({
          ...params,
          invoiceType: 'adjusted',
        }),
      select: (res) => ({
        total: _.get(res, 'count', 0),
        rows: !res?.rows
          ? []
          : _.flatMap(res.rows, (row, idx) => {
              // hóa đơn gốc
              const base = {
                ...row,
                Relate: null,
                id: idx + 1,
                Related: null,
              }

              // hóa đơn liên quan
              const relatedItems = (row.Related || [])
                .map((item) => {
                  if (
                    (item?.issueStatus == 'AUTHORITY_CODE_NOT_GIVEN' &&
                      item?.classify === 'HD') ||
                    (item?.sendTaxStatus == 'INVOICE_INVALID' &&
                      item?.classify === 'MTT')
                  ) {
                    return null
                  }

                  return {
                    ...row,
                    Relate: item,
                    id: idx + 1,
                    Related: null,
                  }
                })
                .filter(Boolean)

              return [...relatedItems.reverse(), base]
            }),
      }),
    }),
}
